export const isNewEvent = (event) => {
  return !event || !event.id || event.id === null;
};
